module.exports = __webpack_public_path__ + "aw.no1.b6e2511a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/aw.no1.jpg
// module id = +QTi
// module chunks = 0